// extracted by mini-css-extract-plugin
export default {"description":"qtmVB4V6Ks3NJnQE5boxi"};